import React from "react"
import { Link } from "react-router-dom"
import { Card, CardBody, Col, Container, Row } from "reactstrap"

// import images
import logodark from "../../assets/images/darklogo.png"
import logolight from "../../assets/images/whitelogo.png"
const landingUrl = process.env.REACT_APP_LANDING_URL;



const ConfirmMail = () => {

  //meta title
  document.title="Confirm Mail | BizServe";

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">

        <Container>
          <Row>
            <Col lg={12}>
              <div className="text-center mb-5 text-muted">
                <Link to="/dashboard" className="d-block auth-logo">
                  <img
                    src={logodark}
                    alt=""
                    height="50"
                    className="auth-logo-dark mx-auto"
                  />
                  <img
                    src={logolight}
                    alt=""
                    height="50"
                    className="auth-logo-light mx-auto"
                  />
                </Link>
                {/* <p className="mt-3">React Admin & Dashboard Template</p> */}
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card>
                <CardBody>
                  <div className="p-2">
                    <div className="text-center">
                      <div className="avatar-md mx-auto">
                        <div className="avatar-title rounded-circle bg-light">
                          <i className="bx bx-mail-send h1 mb-0 text-primary"></i>
                        </div>
                      </div>
                      <div className="p-2 mt-4">
                        <h4>Signup request sent! </h4>
                        <p className="text-muted">
                          Your signup request has been submitted for admin approval. We will keep you updated via the email you provided. Once approved, you’ll be able to purchase a subscription and book experts. Thank you for your patience and cooperation!
                        </p>
                        <div className="mt-4">
                          {/* <Link to="/dashboard" className="btn btn-primary">
                            Back to Home
                          </Link> */}
                          <a href={landingUrl} className="btn btn-primary">
                            Back to Home
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  © {new Date().getFullYear()} BizServe. Crafted with{" "}
                  <i className="mdi mdi-heart text-danger"></i> by BizServe LLC
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ConfirmMail
